import { useEffect, useMemo, useState } from 'react'
import { CustomerService, ErrorConstant } from 'utility'

export const GetCumulativeReportCustomerList = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const options = useMemo(
        () =>
            data.map(ele => ({
                value: ele.unique_id,
                text: ele.customer_name,
            })),
        [data],
    )

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await CustomerService.cumulativeReportList()
                setData(result.Items || [])
            } catch (error) {
                setError(error.message || ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [])

    return { data, options, error, loading }
}
